<template>
  <v-dialog
    v-model="dialog"
    :max-width="dialogWidth"
  >
    <v-card class="hidden-xs-only">
      <v-layout align-start justify-center row fill-height>
        <v-flex xs6>
          <v-img
            class="white--text align-end justify-end"
            height="400px"
            :src="image"
          >
          </v-img>
        </v-flex>
        <v-flex xs6>
          <v-card-text class="card-text">
            <v-layout align-end justify-end column>
              <v-btn color="white" icon @click="close()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
            <v-layout align-center justify-space-between column fill-height>
              <p class="title">Sample Menu*</p>
              <ul>
                <li>Blinis and carrot gravlax</li>
                <li>Mushroom pâté, sourdough country loaf</li>
                <li>Beet bourguignon, seasonal veg</li>
                <li>Bûche de Noël</li>
                <li>Indulgent surprise to take home</li>
              </ul>
              <span class="asterix">*Subject to change depending on produce availability</span>
            </v-layout>
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-card>
    <v-card class="hidden-sm-and-up">
      <v-img
        class="white--text"
        height="150px"
        :src="image"
      >
        <v-layout column align-end justify-space-between fill-height>
          <v-flex>
            <v-btn color="white" icon @click="close()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-img>
      <v-card-text class="card-text-sm">
        <p class="title">Sample Menu*</p>
        <ul>
          <li>Blinis and carrot gravlax</li>
          <li>Mushroom pâté, sourdough country loaf</li>
          <li>Beet bourguignon, seasonal veg</li>
          <li>Bûche de Noël</li>
          <li>Indulgent surprise to take home</li>
        </ul>
        <p class="asterix">*Subject to change depending on produce availability</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    cardClasses() {
      return this.$vuetify.breakpoint.xsOnly ? ['card-sm'] : []
    },
    dialogWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '300'
        case 'sm': return '800'
        case 'md': return '800'
        case 'lg': return '800'
        case 'xl': return '800'
      }
      return '800'
    },
  },
  data: () => ({
    dialog: false,
    image: require('@/assets/images/a-french-christmas-pop-up.jpg?vuetify-preload')
  }),
  methods: {
    close() {
      this.dialog = false;
      this.$emit('close');
    },
    go() {
      this.close();
      this.$router.push({name:'a-french-christmas'});
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.$emit('close');
      }
    },
    show () {
      this.dialog = this.show;
    },
  }
}
</script>

<style scoped>
.card-text .title {
  font-size: 20px;
  margin-top: 10px;
  text-align: center;
  font-weight: bold;
}

.card-text-sm .title {
  margin-top: 10px;
  text-align: center;
  font-weight: bold;
}

.card-title {
  margin: 10px 10px 10px 0;
  padding: 0 10px;
}

.ref {
  font-size: 12px;
  margin: 10px 15px;
}

.asterix {
  font-size: 12px;
  font-style: italic;
  text-align: center;
  font-weight: normal;
}

ul {
  margin: 20px 0;
  padding: 0;
  list-style: none;
  font-size: 13px;
  text-align: center;
}
</style>
